import React from 'react';

export default function InfoBox (props) {
    return (
        <>
            <div className="generics_infobox">
                <div className="generics_infobox_label">{props.label}</div>
                <div className="generics_infobox_value">{props.value}</div>
            </div>
        </>
    );
}
